import { authenticationService } from '@/application/services/api-clients/login-service';
import { requestFunnel } from '@/application/api';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getAuditReport = async (documentKey, reportType) => {
  const options = getOptions();
  options.responseType = 'blob';
  return (await requestFunnel.get(`/documents/${documentKey}/${reportType}`, options)).data;
};

export const listCMFDocuments = async () => {
  return (await requestFunnel.get('/documents/list')).data;
};
